import React from "react";
import styled from "styled-components";
import { Button } from "antd";
import { COLORS } from "../constants/Colors";

const MyButton = styled(({ isPrimary, bgColor, ...rest }) => (
  <Button {...rest} />
)).attrs((props) => {
  const { isPrimary, disabled } = props;
  return {
    isPrimary,
  };
})`
  font-weight: 600;
  color: ${({ isPrimary }) => (isPrimary ? COLORS.White : COLORS.GreenBrown)};
  background-color: ${({ bgColor, isPrimary }) => {
    return bgColor ? bgColor : isPrimary ? COLORS.GreenBrown : COLORS.White;
  }};
  border: solid 0.5px ${COLORS.GreenBrown};
  border-radius: 8px;
  pointer-events: ${({ disabled }) => {
    return disabled ? "none" : null;
  }};

  &:hover {
    color: ${COLORS.GreenBrown} !important;
    background-color: ${COLORS.White} !important;
    border: solid 0.5px ${COLORS.GreenBrown} !important;
  }
`;

export default MyButton;
